import { Directive, ElementRef, Input, Renderer, OnChanges, SimpleChanges} from '@angular/core';

@Directive({
    selector: '[sortingClass]'
})
/**
 * this directive managed sorting icon for <th> element by changing class=sorting | sorting_desc | sorting_asc
 */
export class SortingClassDirective implements OnChanges {

    @Input() fieldName: any;
    @Input() sort: any;
    @Input() order: any;

    constructor(public el: ElementRef, public renderer: Renderer) {
    }

    ngOnChanges(changes: SimpleChanges) {
        let className = this.getClassName();
        this.el.nativeElement.className = className;
    }

    getClassName(){
        let className = 'sorting';

        if(this.fieldName === this.sort && this.order === '0'){
            className = 'sorting_desc';
        } else if(this.fieldName === this.sort && this.order === '1') {
            className = 'sorting_asc';
        }
        return className;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/datatables/datatable.directives.ts